import axiosInstance from '../utils/AxiosConfig';

export const getStaff = async () => {
  try {
    const response = await axiosInstance.get('/staff');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching staff:', error);
    throw new Error('Error fetching staff');
  }
};

export const getProfile = async () => {
  try {
    const response = await axiosInstance.get('/staff/profile');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching staff:', error);
    throw new Error('Error fetching staff');
  }
};

export const updateStaffProfile = async (updatedUser) => {
  try {
    const response = await axiosInstance.put('/staff/profile', {
      first_name: updatedUser.firstName, 
      last_name: updatedUser.lastName, 
      phone: updatedUser.phone, 
      address: updatedUser.address, 
      birth_date: updatedUser.birthDate 
    });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching staff:', error);
    throw new Error('Error fetching staff');
  }
};

export const uploadProfilePicture = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosInstance.post('/staff/uploadProfilePicture', formData, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
  });
  return response.data.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await axiosInstance.post('/staff/changePassword', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error_message);
  }
};

export const resetPassword = async (email, password, deleteSession) => {
  try {
    const response = await axiosInstance.post('/staff/resetPassword', {
      delete_session: deleteSession,
      email: email,
      password: password
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error_message);
  }
};

export const updateStatus = async (
  email,
  role,
  status,
  position,
  deleteSession,
  manager,
  scopes = [],
  canAccessWebDashboard = false
) => {
  try {
    const response = await axiosInstance.post('/staff/updateStatus', {
      can_access_web_dashboard: canAccessWebDashboard,
      delete_session: deleteSession,
      email: email,
      role_id: role,
      status_id: status,
      position_id: position,
      manager_id: manager,
      scopes: scopes
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error.response.data.error_message);
  }
};

export const updateStaff = async (userData) => {
  try {
    const response = await axiosInstance.post('/staff/updateStatus', {
      email: userData.email,
      ci: userData.ci,
      first_name: userData.firstName,
      last_name: userData.lastName,
      phone: userData.phone,
      role_id: userData.roleId,
      date_of_admission: userData.dateOfAdmission.format('YYYY-MM-DDT00:00:00'),
      status_id: userData.status,
      address: userData.address,
      birthdate: userData.birthdate.format('YYYY-MM-DDT00:00:00'),
      position_id: userData.position,
      can_access_web_dashboard: userData.canAccessWebDashboard ?? false,
      delete_session: userData.deleteSession ?? false,
      manager_id: userData.manager ? userData.manager.email : null,
      scopes: userData.scopes || []
    });
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.error_message || 'Error updating staff');
  }
};

export const createStaff = async (userData) => {
  try {
    const managerId = userData.manager ? userData.manager.email : null
    const formattedBirthDate = userData.birthdate.format('YYYY-MM-DDT00:00:00');
    const formattedDateOfAdmission = userData.dateOfAdmission.format('YYYY-MM-DDT00:00:00');       
    const response = await axiosInstance.post('/staff', {
      email: userData.email,
      ci: userData.ci,
      first_name: userData.firstName,
      last_name: userData.lastName,
      phone: userData.phone,
      password: userData.password,
      role_id: userData.roleId,
      date_of_admission: formattedDateOfAdmission,
      status: userData.status,
      address: userData.address,
      birthdate: formattedBirthDate,
      position: userData.position,
      can_access_web_dashboard: userData.canAccessWebDashboard ?? false,
      manager_id: managerId,
      scopes: userData.scopes || []
    });
    return response.data.data;
  } catch (error) {
    console.error('Error creating staff:', error);
    // Se relanza el error original para que el caller pueda leer error.response.status (ej. 409)
    throw error;
  }
};

// export const getStaffRegularSchedule = async (locationId, email) => {
//   const response = await axiosInstance.get(`/staff_schedule/${email}/regular`, {
//     params: {
//       locationId: locationId
//     }
//   });
//   return response.data.data;
// };

export const getAllStaffSchedule = async (locationId, from, to) => {
  const response = await axiosInstance.get(`/staff_schedule/regular`, {
    params: {
      locationId: locationId,
      from: from,
      to: to
    }
  });
  return response.data.data;
};

export const updateStaffRegularSchedule = async (locationId, email, schedule) => {
  const response = await axiosInstance.post(`/staff_schedule/${email}`, {
    location_id: locationId,
    schedule: schedule
  });
  return response.data.data;
};

// export const updateStaffExceptionSchedule = async (locationId, email, schedule) => {
//   const response = await axiosInstance.post(`/staff_schedule/${email}/exception`, schedule);
//   return response.data.data;
// };
